"use strict";

exports.__esModule = true;
exports["default"] = useMediaQuery;
var _react = require("react");
function useMediaQuery(query) {
  var _useState = (0, _react.useState)(false),
    matches = _useState[0],
    setMatches = _useState[1];
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      var media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      var listener = function listener() {
        return setMatches(media.matches);
      };
      window.addEventListener('resize', listener);
      return function () {
        return window.removeEventListener('resize', listener);
      };
    }
  }, [matches, query]);
  return matches;
}